import { Input } from "antd";
import { useInputDebouncer } from "@vyne-shared/utils/useInputDebouncer";

/** Properties for the patient name filter. */
export interface PatientSearchProps {
    /** Current filter state. */
    readonly patientSearchFilter: string;
    /** Dispatcher used to change the filter state. */
    readonly setPatientSearchFilter: React.Dispatch<string>;
}

/** Input box used to filter items by patient name. */
export const PatientSearch = ({ patientSearchFilter, setPatientSearchFilter }: PatientSearchProps) => {
    const [rawValue, setRawValueDebounced] = useInputDebouncer(200, "", patientSearchFilter, setPatientSearchFilter);

    return (
        <Input.Search
            id="patient-search-filter"
            className="patient-search-filter"
            placeholder="Search Patients"
            autoComplete="off"
            type="search"
            allowClear
            value={rawValue}
            onChange={(e) => {
                const val = e.target.value;

                if (val) {
                    // echo user changes immediately for maximum responsiveness
                    // debounce non-empty values into the filter
                    setRawValueDebounced(val);
                } else {
                    // apply empty value (making filter non-applicable) immediately
                    setPatientSearchFilter("");
                }
            }}
        />
    );
};
